import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { glass } from "./portal";
import { useProject } from "@/lib/portal/useProject";
import { Download, Receipt } from "lucide-react";
import { format } from "date-fns";
import { it } from "date-fns/locale";

export const Route = createFileRoute("/_authenticated/portal/invoices")({
  component: InvoicesPage,
});

function InvoicesPage() {
  const { data: project } = useProject();
  const { data: invoices } = useQuery({
    queryKey: ["portal", "invoices"],
    queryFn: async () => (await supabase.from("invoices").select("*").order("issued_at", { ascending: false })).data ?? [],
    enabled: !!project,
  });

  const upcoming = (invoices ?? []).filter((i) => i.status === "upcoming");
  const paid = (invoices ?? []).filter((i) => i.status === "paid");

  return (
    <div className="max-w-6xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">Fatture</h1>
        <p className="text-white/60 mt-1">Storico, PDF e prossimi pagamenti.</p>
      </div>

      {upcoming.length > 0 && (
        <div className={`${glass} p-6 bg-gradient-to-br from-amber-500/10 to-orange-500/10`}>
          <div className="text-xs uppercase tracking-widest text-amber-300">In scadenza</div>
          {upcoming.map((i) => (
            <div key={i.id} className="mt-2 flex items-center justify-between flex-wrap gap-2">
              <div>
                <div className="font-medium">{i.invoice_number} · {i.description}</div>
                <div className="text-sm text-white/60">Scade il {i.due_date ? format(new Date(i.due_date), "d MMM yyyy", { locale: it }) : "—"}</div>
              </div>
              <div className="text-2xl font-semibold">{i.currency} {i.amount.toLocaleString("it-CH")}</div>
            </div>
          ))}
        </div>
      )}

      <div className={`${glass} overflow-hidden`}>
        <div className="grid grid-cols-[1fr_auto_auto_auto] gap-4 px-5 py-3 text-[10px] uppercase tracking-widest text-white/40 border-b border-white/5">
          <div>Fattura</div><div>Data</div><div>Importo</div><div>Status</div>
        </div>
        {paid.map((i) => (
          <div key={i.id} className="grid grid-cols-[1fr_auto_auto_auto] gap-4 px-5 py-4 items-center border-b border-white/5 last:border-b-0">
            <div className="flex items-center gap-3">
              <div className="h-9 w-9 rounded-lg bg-white/5 grid place-items-center"><Receipt className="h-4 w-4 text-white/60" /></div>
              <div>
                <div className="text-sm font-medium">{i.invoice_number}</div>
                <div className="text-xs text-white/50">{i.description}</div>
              </div>
            </div>
            <div className="text-sm text-white/60">{format(new Date(i.issued_at), "d MMM yyyy", { locale: it })}</div>
            <div className="text-sm font-medium">{i.currency} {i.amount.toLocaleString("it-CH")}</div>
            <div className="flex items-center gap-3">
              <span className="text-xs px-2 py-1 rounded-full bg-emerald-500/20 text-emerald-300">Pagata</span>
              <button className="p-2 rounded-lg hover:bg-white/5" title="Scarica PDF"><Download className="h-4 w-4 text-white/60" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
